export default __webpack_public_path__ + "static/N0094-98a7315ee93c17ba9f8553e9a6616fc5.png";